<template>
  <div>
    <h1 class="d-flex align-items-center">
      Адміністратори

      <b-button class="add-user" variant="primary" @click="showInvitation">
        <b-icon icon="plus"></b-icon>
        Додати адміністратора
      </b-button>
    </h1>
    <b-card class="pt-2">
      <b-overlay :show="isLoading" spinner-variant="primary" rounded="lg">
        <adminItem :a="a" v-for="a in admins" :key="a.id" />
      </b-overlay>
    </b-card>
    <inviteModal ref="inviteAdminModal" :role="'admin'" />
  </div>
</template>

<script>
import inviteModal from "@/components/admin/modals/invite-user.vue";
import adminItem from "@/components/admin/list-items/administrator-list-item.vue";
export default {
  components: {
    adminItem,
    inviteModal,
  },
  data() {
    return {
      isLoading: false,
      showInviteModal: false,
      admins: [],
    };
  },
  methods: {
    showInvitation() {
      this.$refs.inviteAdminModal.showInviteModal = true;
    },
    async getAdministrators() {
      this.isLoading = true;
      let args = {
        collectionName: "users",
        where: ["role", "==", "admin"],
      };
      let result = await this.$db.getCollection(args);
      this.isLoading = false;
      this.admins = result.docs;
    },
  },
  mounted() {
    this.getAdministrators();
  },
};
</script>

<style lang="scss" scoped>
h1 {
  .btn {
    margin-left: auto;
    svg {
      margin-right: 8px;
      line-height: 1;
    }
  }
}
</style>
